import merge from 'lodash-es/merge';
import isFunction from 'lodash-es/isFunction';
import isString from 'lodash-es/isString';
import pick from 'lodash-es/pick';
import each from 'lodash-es/each';
import omit from 'lodash-es/omit';
import updateStyle from '../css/updateStyle';
import lookAndFeel from '../lookAndFeel';
import updateStyleByRef from '../css/updateStyleByRef';
import {renderControls} from '../renderControls';
import frameProps from '../css/frameProps';
import getDisabledStyle from '../css/disabledStyle';
import Control from './control';
import { getDefaultControlStyle, getDefaultControl } from './icon.defaults';

export default class Icon extends Control {
  constructor(instance, path, nicePath) {
    super(instance, path, nicePath);

    // Add url API with formatter support
    this.addApi(this, 'url', () =>
      this._checkDataOption('url', this._controlOptions.url || 'themes/css/img/icon-placeholder.png'), {
      formatter: 'urlFormatter'
    });
  }

  renderElement() {
    const control = this;
    // const options = this._controlOptions;
    //const options = control.options;
    const instance = this.instance;
    const path = this.path;
    if (!control.el) {
      // console.log('control has no el yet', control.el);
      control.el = getDefaultControl();
      if (!control.isLayoutMode) {
        control.el.addEventListener('mouseover', function(ev) {
          if (ev.target === control.el.firstChild) {
            // console.log('icon over');
            control.isHover = true;
            control.render();
          }
        });
        control.el.addEventListener('mouseout', function(ev) {
          if (ev.target === control.el.firstChild) {
            // console.log('icon out');
            control.isHover = false;
            control.render();
          }
        });

        control.el.addEventListener('click', function(ev) {
          if (ev.target === control.el.firstChild) {
            // console.log('icon click');
            if (control.options.trigger) {
              if (!isFunction(control.options.trigger)) {
                console.error("icon's click trigger should be a function", control.options.trigger);
              } else {
                control.options.trigger.apply(this, [control.options, instance, control, path, ev]);
              }
            }

            if (control.options.event) {
              if (!isString(control.options.event)) {
                console.error("icon's click event should be a string", control.options.event);
              } else {
                instance.fire(
                  control.options.event,
                  pick(control.options, ['name', 'value', 'type', 'gridElement']),
                  control,
                  path,
                  ev
                );
              }
            }

            control.doResetReload();
          }
        });
      }
    }

    let iconUrl = control.url !== undefined ? control.url + '' : '';
    if (iconUrl) {
      var libicon = _.find(instance.options.icons, ['name', iconUrl]);
      if (libicon) {
        iconUrl = libicon.url;
      }
    }

    // console.log('render icon', control.options);
    var stylePatch = {};
    var bodyStylePatch = {};
    var defaultStyle = getDefaultControlStyle(instance);
    var bodyEl = control.el.getElementsByClassName('body')[0];
    // var frameProps = [
    //   'top',
    //   'left',
    //   'right',
    //   'bottom',
    //   'margin',
    //   'position',
    //   'display',
    //   'width',
    //   'height',
    //   'filter',
    // ];

    merge(stylePatch, defaultStyle.normal);
    merge(bodyStylePatch, defaultStyle.body.normal);
    switch (control.options.stretch) {
      case 'height':
        delete bodyStylePatch.width;
        break;
      case 'width':
        delete bodyStylePatch.height;
        break;
    }

    if (control.options.style && control.options.style.normal) {
      merge(stylePatch, pick(control.options.style.normal, frameProps));
      merge(bodyStylePatch, omit(control.options.style.normal, frameProps));
    }

    merge(stylePatch, control.frameStyle);

    if (control.isHover) {
      merge(stylePatch, defaultStyle.hover);
      merge(bodyStylePatch, defaultStyle.body.hover);
      if (control.options.style && control.options.style.hover) {
        merge(stylePatch, pick(control.options.style.hover, frameProps));
        merge(bodyStylePatch, omit(control.options.style.hover, frameProps));
      }
    }

    bodyEl.setAttribute('src', iconUrl || defaultStyle.url);

    // if (control.text) {
    //   bodyEl.setAttribute('title', control.text);
    // }

    if (control.disabled) {
      merge(stylePatch, getDisabledStyle());
      if (control.options.style && control.options.style.disabled) {
        merge(stylePatch, control.options.style.disabled);
      }

      if (control.isLayoutMode) {
        delete stylePatch.pointerEvents;
      }
    }

    let scheme = lookAndFeel(control.options.lookAndFeel, stylePatch.height);

    // console.log('scheme', control.options.lookAndFeel, scheme);
    updateStyleByRef([stylePatch, bodyStylePatch], scheme);
    // console.log('boxShadow', bodyStylePatch.boxShadow);
    updateStyle(control.el, stylePatch, control.currentStyle);
    control.currentStyle = stylePatch;

    updateStyle(bodyEl, bodyStylePatch, control.currentBodyStyle);
    control.currentBodyStyle = bodyStylePatch;

    if (control.options.controls) {
      each(control.options.controls, function(ctrl) {
        ctrl.lookAndFeel = merge({}, control.options.lookAndFeel, ctrl.lookAndFeel);
      });
      renderControls(instance, path,control.nicePath, control.el);
    }

    return control.el;
  }
}
